"use strict";

var pTop;

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
        "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), 
    Constructor;
}

function _typeof(obj) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    })(obj);
}

!function(modules) {
    var installedModules = {};
    function __webpack_require__(moduleId) {
        if (installedModules[moduleId]) return installedModules[moduleId].exports;
        var module = installedModules[moduleId] = {
            i: moduleId,
            l: !1,
            exports: {}
        };
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.l = !0, module.exports;
    }
    __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function(exports, name, getter) {
        __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
            enumerable: !0,
            get: getter
        });
    }, __webpack_require__.r = function(exports) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(exports, "__esModule", {
            value: !0
        });
    }, __webpack_require__.t = function(value, mode) {
        if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
        if (4 & mode && "object" === _typeof(value) && value && value.__esModule) return value;
        var ns = Object.create(null);
        if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
            enumerable: !0,
            value: value
        }), 2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function(key) {
            return value[key];
        }.bind(null, key));
        return ns;
    }, __webpack_require__.n = function(module) {
        var getter = module && module.__esModule ? function() {
            return module.default;
        } : function() {
            return module;
        };
        return __webpack_require__.d(getter, "a", getter), getter;
    }, __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 0);
}([ function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, function(module, __webpack_exports__, __webpack_require__) {
    __webpack_require__.r(__webpack_exports__);
    var cmn = {}, _cmnEvt = function() {
        function _cmnEvt() {
            var _this = this;
            _classCallCheck(this, _cmnEvt), this.props = {
                scf: !0,
                scpt: 0,
                scpl: 0,
                wpw: 0,
                wph: 0,
                wdw: 0,
                wdh: 0,
                pmd: !1,
                bkp: "(min-width: 768px)",
                rst: !1,
                sct: !1,
                rsd: 250,
                scd: 100
            }, this.getProps(), this.eventSet(), $(window).on("load", function() {
                _this.getProps();
            });
        }
        return _createClass(_cmnEvt, [ {
            key: "getProps",
            value: function(scroll) {
                scroll || (cmn.p.media = window.matchMedia(this.props.bkp).matches ? "pc" : "sp", 
                cmn.p.winH = window.innerHeight, cmn.p.winW = window.innerWidth, cmn.p.docH = $(document).height(), 
                this.props.scf = !0), cmn.p.scrT = $(window).scrollTop(), cmn.p.scrL = $(window).scrollLeft();
            }
        }, {
            key: "eventSet",
            value: function() {
                var _this2 = this;
                this.props.pmd = cmn.p.media, this.props.scpt = cmn.p.scrT, this.props.scpl = cmn.p.scrL, 
                this.props.wpw = cmn.p.winW, this.props.wph = cmn.p.winH, $(window).on("scroll", function() {
                    _this2.getProps(!0), _this2.exe("scroll"), _this2.props.scf && (_this2.getProps(), 
                    _this2.exe("scrollF"), _this2.props.scf = !1), cmn.p.scrT !== _this2.props.scpt && (_this2.exe("scrollY"), 
                    _this2.props.scpt = cmn.p.scrT), cmn.p.scrL !== _this2.props.scpl && (_this2.exe("scrollX"), 
                    _this2.props.scpl = cmn.p.scrL), !1 === _this2.props.sct && (_this2.props.sct = setTimeout(function() {
                        _this2.exe("scrollD"), _this2.props.sct = !1;
                    }, _this2.props.scd));
                }), $(window).on("resize", function() {
                    _this2.getProps(), _this2.exe("resize"), cmn.p.winH !== _this2.props.wph && (_this2.exe("resizeH"), 
                    _this2.props.wph = cmn.p.winH), cmn.p.winW !== _this2.props.wpw && (_this2.exe("resizeW"), 
                    _this2.props.wpw = cmn.p.winW, _this2.props.pmd !== cmn.p.media && ("pc" === cmn.p.media ? _this2.exe("toPc") : _this2.exe("toSp"), 
                    _this2.props.pmd = cmn.p.media)), !1 !== _this2.props.rst && clearTimeout(_this2.props.rst), 
                    _this2.props.rst = setTimeout(function() {
                        _this2.exe("resizeD"), cmn.p.winH !== _this2.props.wdh && (_this2.exe("resizeDH"), 
                        _this2.props.wdh = cmn.p.winH), cmn.p.winW !== _this2.props.wdw && (_this2.exe("resizeDW"), 
                        _this2.props.wdw = cmn.p.winW), _this2.props.scf = !0;
                    }, _this2.props.rsd);
                });
            }
        }, {
            key: "exe",
            value: function(type) {
                var len = cmn.e[type].length;
                if (!len) return !1;
                for (var i = 0; i < len; i++) cmn.i[cmn.e[type][i][0]][cmn.e[type][i][1]]();
            }
        } ]), _cmnEvt;
    }(), _cmnMth = function() {
        function _cmnMth() {
            _classCallCheck(this, _cmnMth);
        }
        return _createClass(_cmnMth, [ {
            key: "arrayShuffle",
            value: function(array) {
                for (var i = array.length - 1; 0 < i; i--) {
                    var r = Math.floor(Math.random() * (i + 1)), tmp = array[i];
                    array[i] = array[r], array[r] = tmp;
                }
                return array;
            }
        }, {
            key: "rnd",
            value: function(int) {
                return Math.floor(Math.random() * (int + 1));
            }
        }, {
            key: "raw",
            value: function(str) {
                return str.replace(/<.+?>/, "");
            }
        } ]), _cmnMth;
    }(), AnchorLink = function() {
        function AnchorLink(name) {
            var _this3 = this;
            _classCallCheck(this, AnchorLink), this.name = name, this.option = {
                customData: "data-anchor",
                namespace: "anchor",
                durationBase: 250,
                durationRatio: 12,
                easing: "easeInOutCubic"
            }, $(function() {
                $("[" + _this3.option.customData + "]")[0] && _this3.init();
            });
        }
        return _createClass(AnchorLink, [ {
            key: "init",
            value: function() {
                var _this4 = this;
                this.$tgt = $("[" + this.option.customData + "]"), this.$tgt.off("click." + this.option.namespace), 
                this.$tgt.on("click." + this.option.namespace, function(val) {
                    cmn.p.autoScroll || cmn.p.spNav || "" !== (val = $(val.currentTarget).attr(_this4.option.customData)) && _this4.scroll(val);
                });
            }
        }, {
            key: "scroll",
            value: function(target, duration, distance) {
                if (!/^0$|^[1-9]\d*$/.test(target)) {
                    if (!$(target)[0]) return;
                    target = $(target).eq(0).offset().top;
                }
                target = Math.max(0, target), target = Math.round(target + cmn.p.winH > cmn.p.docH ? cmn.p.docH - cmn.p.winH : target), 
                distance = Math.abs(target - cmn.p.scrT), duration = duration || Math.round(this.option.durationBase + distance / this.option.durationRatio), 
                cmn.p.autoScroll = 1, $("html, body").stop(!0, !1).animate({
                    scrollTop: target
                }, duration, this.option.easing, function() {
                    cmn.p.autoScroll = 0;
                });
            }
        } ]), AnchorLink;
    }(), HeaderCategory = function() {
        function HeaderCategory(name) {
            var _this5 = this;
            _classCallCheck(this, HeaderCategory), this.name = name, this.option = {
                default_width: 270,
                header_height: 128
            }, $(function() {
                $("header.header")[0] && _this5.init();
            });
        }
        return _createClass(HeaderCategory, [ {
            key: "init",
            value: function() {
                var _this6 = this;
                this.z = 1, this.scrollY = 0, this.$hdBg = $(".headerBg"), this.$link_a = $("[data-hdnv-a]"), 
                this.$link_b = $("[data-hdnv-b]"), this.$link_c = $("[data-hdnv-c]"), this.$link_a.children("a").on("click", function(e) {
                    e.stopPropagation(), e.preventDefault();
                }), this.$link_a.on("mouseenter mouseleave", function(e) {
                    "sp" !== cmn.p.media && _this6.hover_a($(e.currentTarget), e.type);
                }), this.$link_b.on("mouseenter mouseleave", function(e) {
                    "sp" !== cmn.p.media && _this6.hover_b($(e.currentTarget), e.type);
                }), this.$link_c.on("mouseenter mouseleave", function(e) {
                    "sp" !== cmn.p.media && _this6.hover_c($(e.currentTarget), e.type);
                }), cmn.e.toPc.push([ this.name, "reset" ]), cmn.e.toSp.push([ this.name, "reset" ]);
            }
        }, {
            key: "hover_a",
            value: function($this, type) {
                var nvHgt, _this7 = this, $wrap = $this.find(".hdnv");
                $wrap.off("wheel.header"), this.scrollY = 0, "mouseenter" === type && (nvHgt = $this.find(".hdnv__in").innerHeight(), 
                this.$hdBg.addClass("is-shown"), $this.css({
                    zIndex: ++this.z
                }), $wrap.css({
                    height: nvHgt,
                    transform: "translateY(0px)"
                }), 0 < this.option.header_height + nvHgt - cmn.p.winH + 20 && $wrap.on("wheel.header", function(e) {
                    var deltaY = e.originalEvent.deltaY, scrollLimitY = _this7.option.header_height + nvHgt - cmn.p.winH + 20;
                    _this7.scrollY += deltaY, _this7.scrollY < 0 && (_this7.scrollY = 0), scrollLimitY < _this7.scrollY && (_this7.scrollY = scrollLimitY), 
                    $wrap.css({
                        transform: "translateY(" + -_this7.scrollY + "px)"
                    }), e.preventDefault(), e.stopPropagation();
                })), "mouseleave" === type && (this.$hdBg.removeClass("is-shown"), $wrap.css({
                    height: 0
                }).off("wheel.header"));
            }
        }, {
            key: "hover_b",
            value: function($this, type) {
                var wid, $wrap = $this.closest(".hdnv"), $low = $this.find(".hdnv__ls__lw");
                "mouseenter" === type && ($this.addClass("is-current"), $wrap.addClass("is-hovered"), 
                $low[0] && (wid = $this.find(".hdnv__ls__lw__ls").innerWidth(), $low.addClass("is-shown"), 
                $wrap.css({
                    width: this.option.default_width + wid
                }))), "mouseleave" === type && ($wrap.removeClass("is-hovered"), $this.removeClass("is-current"), 
                $low[0] && ($wrap.css({
                    width: this.option.default_width
                }), $low.removeClass("is-shown")));
            }
        }, {
            key: "hover_c",
            value: function($low, type) {
                $low = $low.closest(".hdnv__ls__lw");
                "mouseenter" === type && $low.addClass("is-hovered"), "mouseleave" === type && $low.removeClass("is-hovered");
            }
        }, {
            key: "reset",
            value: function() {
                var _this8 = this;
                this.scrollY = 0, this.$hdBg.removeClass("is-shown"), this.$link_a.each(function(i, el) {
                    $(el).find(".hdnv").css({
                        height: 0,
                        width: _this8.option.default_width
                    }).removeClass("is-hovered").off("wheel.header");
                }), this.$link_b.each(function(i, $low) {
                    var $this = $($low), $low = $this.find(".hdnv__ls__lw");
                    $this.removeClass("is-current"), $low[0] && $low.removeClass("is-shown is-hovered");
                });
            }
        } ]), HeaderCategory;
    }(), HeaderCustomer = function() {
        function HeaderCustomer(name) {
            var _this9 = this;
            _classCallCheck(this, HeaderCustomer), this.name = name, this.option = {}, $(function() {
                $("header.header")[0] && _this9.init();
            });
        }
        return _createClass(HeaderCustomer, [ {
            key: "init",
            value: function() {
                var _this10 = this;
                this.$btn = $("header li.cstmBtn"), this.$btn.on("mouseenter", function(e) {
                    _this10.$btn.addClass("is-active");
                }), this.$btn.on("mouseleave", function(e) {
                    _this10.$btn.removeClass("is-active");
                });
            }
        } ]), HeaderCustomer;
    }(), HeaderSpbtn = function() {
        function HeaderSpbtn(name) {
            var _this11 = this;
            _classCallCheck(this, HeaderSpbtn), this.name = name, $(function() {
                $("header.header")[0] && _this11.init();
            });
        }
        return _createClass(HeaderSpbtn, [ {
            key: "init",
            value: function() {
                this.$h__in2 = $(".header__in2"), this.$h__spbtn = $(".header__spbtn"), this.$h__spmn = $(".header__spmn"), 
                this.$h__spmn__in = $(".header__spmn__in"), this.$headerBg = $(".headerBg"), this.$hdspA = $("[data-hdspbtn-a]"), 
                this.$hdspB = $("[data-hdspbtn-b]"), this.$hdspRtnA = $("[data-hdsprtn-a]"), this.$hdspRtnB = $("[data-hdsprtn-b]"), 
                this.$srch = $("#headerSearch"), this.$main = $("#main"), this.$foot = $("#footer"), 
                this.event(), cmn.e.toPc.push([ this.name, "closeMenu" ]), cmn.e.toSp.push([ this.name, "closeMenu" ]);
            }
        }, {
            key: "event",
            value: function() {
                var _this12 = this;
                this.$h__spbtn.on("click", function() {
                    _this12.anim || (_this12.$h__spbtn.hasClass("is-open") ? _this12.closeMenu(!0) : _this12.openMenu());
                }), this.$hdspA.on("click", function(e) {
                    _this12.anim || _this12.moveTo($(e.currentTarget), "a");
                }), this.$hdspB.on("click", function(e) {
                    _this12.anim || _this12.moveTo($(e.currentTarget), "b");
                }), this.$hdspRtnA.on("click", function() {
                    _this12.anim || _this12.returnFrom("a");
                }), this.$hdspRtnB.on("click", function() {
                    _this12.anim || _this12.returnFrom("b");
                });
            }
        }, {
            key: "openMenu",
            value: function() {
                var hgt, _this13 = this;
                this.anim || (this.anim = !0, this.$h__spbtn.addClass("is-open"), this.$headerBg.addClass("is-shown"), 
                hgt = this.$h__spmn__in.innerHeight(), this.$h__spmn.css({
                    display: "block"
                }).animate({
                    height: hgt
                }, 400, "easeOutCubic", function() {
                    _this13.$h__spmn.css({
                        height: "auto"
                    }), _this13.scrT = cmn.p.scrT, _this13.scrL = cmn.p.scrL, _this13.$srch.css({
                        display: "none"
                    }), _this13.$main.css({
                        display: "none"
                    }), _this13.$foot.css({
                        display: "none"
                    }), _this13.$h__in2.addClass("is-open"), $(window).scrollTop(0), _this13.anim = !1;

                  	if(pTop == "OFF"){                      
                      $('#shopify-section-header_info').css({
                        display: "none"
                      });
                    }
                }));
            }
        }, {
            key: "closeMenu",
            value: function(sp) {
                var hgt, _this14 = this;
                this.anim || (this.anim = !0, this.$h__spbtn.removeClass("is-open"), this.$headerBg.removeClass("is-shown"), 
                this.$h__in2.removeClass("is-open"), this.$srch.css({
                    display: "block"
                }), this.$main.css({
                    display: "block"
                }), this.$foot.css({
                    display: "block"
                }), $('#shopify-section-header_info').css({
                    display: "flex"
                }), $(window).scrollTop(this.scrT), $(window).scrollLeft(this.scrL), hgt = this.$h__spmn__in.innerHeight(), 
                this.$h__spmn.css({
                    display: "block",
                    height: hgt
                }).animate({
                    height: 0
                }, sp ? 400 : 10, "easeOutCubic", function() {
                    _this14.$h__spmn__in.removeClass("is-low--a is-low--b"), $("[data-hdsptgt-a]").removeClass("is-shown"), 
                    $("[data-hdsptgt-b]").removeClass("is-shown"), setTimeout(function() {
                        _this14.anim = !1;
                    }, sp ? 400 : 10);
                }));
            }
        }, {
            key: "moveTo",
            value: function($tgt, type) {
                var _this15 = this;
                this.anim || (this.anim = !0, ($tgt = $("[data-hdsptgt-" + type + '="' + $tgt.data("hdspbtn-" + type) + '"]')).siblings(".is-shown").removeClass("is-shown"), 
                $tgt.addClass("is-shown"), this.$h__spmn__in.addClass("is-low--" + type), this.goTop(), 
                setTimeout(function() {
                    _this15.anim = !1;
                }, 500));
            }
        }, {
            key: "returnFrom",
            value: function(type) {
                var _this16 = this;
                this.anim || (this.anim = !0, this.$h__spmn__in.removeClass("is-low--" + type), 
                this.goTop(), setTimeout(function() {
                    _this16.anim = !1, $("[data-hdsptgt-" + type + "]").removeClass("is-shown");
                }, 500));
            }
        }, {
            key: "goTop",
            value: function() {
                cmn.p.autoScroll = 1, $("html, body").stop(!0, !1).animate({
                    scrollTop: 0
                }, 500, "easeOutCubic", function() {
                    cmn.p.autoScroll = 0;
                });
            }
        } ]), HeaderSpbtn;
    }(), FixedElemAdjust = function() {
        function FixedElemAdjust(name) {
            var _this17 = this;
            _classCallCheck(this, FixedElemAdjust), this.name = name, $(function() {
                $(".will-be-fixed")[0] && _this17.init();
            });
        }
        return _createClass(FixedElemAdjust, [ {
            key: "init",
            value: function() {
                var _this18 = this;
                this.$hd = $(".will-be-fixed"), cmn.e.toPc.push([ this.name, "check" ]), cmn.e.scrollX.push([ this.name, "check" ]), 
                this.check(), setTimeout(function() {
                    _this18.check();
                }, 500), setTimeout(function() {
                    _this18.check();
                }, 1e3);
            }
        }, {
            key: "check",
            value: function($this, type) {
                "sp" !== cmn.p.media && this.$hd.css({
                    transform: "translateX(" + -cmn.p.scrL + "px)"
                });
            }
        } ]), FixedElemAdjust;
    }(), SortChanger = function() {
        function SortChanger(name) {
            var _this19 = this;
            _classCallCheck(this, SortChanger), this.name = name, this.option = {}, $(function() {
                $("#SortBy")[0] && _this19.init();
            });
        }
        return _createClass(SortChanger, [ {
            key: "init",
            value: function() {
                var _this20 = this;
                this.$select = $("#SortBy"), this.$select.on("change", function() {
                    _this20.sort();
                });
            }
        }, {
            key: "sort",
            value: function($this) {
                var s = window.location.search, o = this.$select.val();
                s = (s = s.replace(/[&?]sort_by=[^&]+/g, "")) ? s + "&sort_by=" + o : "?sort_by=" + o, 
                window.location.search = s;
            }
        } ]), SortChanger;
    }(), ProductVariant = function() {
        function ProductVariant(name) {
            var _this21 = this;
            _classCallCheck(this, ProductVariant), this.name = name, this.option = {
                duration: 150
            }, $(function() {
                $("#product")[0] && _this21.init();
            });
        }
        return _createClass(ProductVariant, [ {
            key: "init",
            value: function() {
                var _this22 = this;
                this.$select = $("#productSelect"), this.checkVariant(), this.$select.on("change", function(e) {
                    _this22.checkVariant();
                });
            }
        }, {
            key: "checkVariant",
            value: function() {
                cmn.p.variant && $('[data-prd-var="' + cmn.p.variant + '"]').fadeOut(this.option.duration), 
                cmn.p.variant = this.$select.val(), $('[data-prd-var="' + cmn.p.variant + '"]').fadeIn(this.option.duration), 
                cmn.i._Carousel.ready && cmn.i._Carousel.checkVariant();
            }
        } ]), ProductVariant;
    }(), ProductFollow = function() {
        function ProductFollow(name) {
            var _this23 = this;
            _classCallCheck(this, ProductFollow), this.name = name, this.option = {
                duration: 150
            }, $(function() {
                $("#product")[0] && _this23.init();
            });
        }
        return _createClass(ProductFollow, [ {
            key: "init",
            value: function() {
                this.$showLine = $(".prd__dat__f"), this.$datFloat = $(".datFloat"), this.getPosition(), 
                cmn.e.scrollD.push([ this.name, "scrollCheck" ]), cmn.e.resizeD.push([ this.name, "getPosition" ]);
            }
        }, {
            key: "getPosition",
            value: function() {
                this.pos = this.$showLine.offset().top, this.scrollCheck();
            }
        }, {
            key: "scrollCheck",
            value: function() {
                this.pos < cmn.p.scrT ? this.$datFloat.addClass("is-shown") : this.$datFloat.removeClass("is-shown");
            }
        } ]), ProductFollow;
    }(), NumberChange = function() {
        function NumberChange(name) {
            var _this24 = this;
            _classCallCheck(this, NumberChange), this.name = name, $(function() {
                $("[data-num-plus]")[0] && _this24.init();
            });
        }
        return _createClass(NumberChange, [ {
            key: "init",
            value: function() {
                var _this25 = this;
                this.init_list = [], this.cur_list = [], this.cart = $("#cart")[0] ? 1 : 0, this.min = this.cart ? 0 : 1, 
                this.$p = $("[data-num-plus]"), this.$m = $("[data-num-minus]"), this.cart && (this.$qty = $(".Quantity"), 
                this.$qty.each(function(i, el) {
                    _this25.init_list.push($(el).val());
                })), this.event();
            }
        }, {
            key: "event",
            value: function() {
                var _this26 = this;
                this.$p.on("click", function(e) {
                    _this26.updateNum($(e.currentTarget), 1);
                }), this.$m.on("click", function(e) {
                    _this26.updateNum($(e.currentTarget), -1);
                }), this.$qty && this.$qty[0] && this.$qty.on("keyup change", function() {
                    _this26.check();
                });
            }
        }, {
            key: "check",
            value: function() {
                var _this27 = this;
                this.cur_list = [], this.$qty.each(function(i, el) {
                    _this27.cur_list.push($(el).val());
                });
                for (var i = 0, len = this.init_list.length; i < len; i++) {
                    var $amt = this.$qty.eq(i).closest(".crtAmt");
                    this.init_list[i] !== this.cur_list[i] ? $amt.addClass("is-changed") : $amt.removeClass("is-changed");
                }
            }
        }, {
            key: "updateNum",
            value: function($tgt, c) {
                $tgt = this.cart ? $tgt.closest(".crtAmt").find(".Quantity") : $tgt.parent(".c-number").find("#Quantity");
                $tgt[0] && (c = +$tgt.val() + c, c = this.min < c ? c : this.min, $tgt.val(c)), 
                this.cart && this.check();
            }
        } ]), NumberChange;
    }(), RecommendScrollSingle = function() {
        function RecommendScrollSingle($wrap) {
            _classCallCheck(this, RecommendScrollSingle), this.$wrap = $wrap, this.option = {}, 
            this.$wrap[0] && this.init();
        }
        return _createClass(RecommendScrollSingle, [ {
            key: "init",
            value: function() {
                this.$doc = $(document), this.$sld_wrap = this.$wrap.find(".recom__fld__in"), this.$sld_body = this.$wrap.find(".recom__fld__ls"), 
                this.$bar_wrap = this.$wrap.find(".recom__bar"), this.$bar_body = this.$wrap.find(".recom__bar__bd"), 
                this.$txt = this.$sld_body.find(".c-prd__in"), this.maxHeight = 0, this.setStatus(), 
                this.setEvents();
            }
        }, {
            key: "setStatus",
            value: function() {
                if (this.wid_sw = this.$sld_wrap.innerWidth(), this.wid_sb = this.$sld_body.innerWidth(), 
                this.wid_bw = this.$bar_wrap.innerWidth(), this.diff = this.wid_sb - this.wid_sw, 
                this.scaleRatio = this.wid_sb / this.wid_bw, this.diff <= 0) return this.$sld_wrap.removeClass("has-bar"), 
                void this.$bar_wrap.removeClass("is-shown");
                this.sliderRatio = this.wid_sw / this.wid_sb, this.remainRatio = 1 - this.sliderRatio, 
                this.scrollLeft = this.$sld_wrap.scrollLeft(), this.scrollRatio = this.scrollLeft / this.diff * this.remainRatio, 
                this.$bar_body.css({
                    width: 100 * this.sliderRatio + "%",
                    left: 100 * this.scrollRatio + "%"
                }), this.heightAdjust(), this.$sld_wrap.addClass("has-bar"), this.$bar_wrap.addClass("is-shown");
            }
        }, {
            key: "setEvents",
            value: function() {
                var _this28 = this;
                this.movingFlag = !1, this.$sld_wrap.off(".recommend"), this.$bar_body.off(".recommend"), 
                this.$doc.off(".recommend"), this.$sld_wrap.on("scroll.recommend", function() {
                    _this28.movingFlag || _this28.check();
                }), this.$bar_body.on("mousedown.recommend", function(e) {
                    "sp" !== cmn.p.media && (_this28.movingFlag = !0, _this28.$bar_body.addClass("is-active"), 
                    _this28.startBarPointerX = e.originalEvent.pageX, _this28.startBarPosition = _this28.$sld_wrap.scrollLeft(), 
                    _this28.$doc.on("mousemove.recommend", function(e) {
                        "sp" !== cmn.p.media && (_this28.moveBarPointerX = e.originalEvent.pageX, _this28.moveBarDiff = _this28.moveBarPointerX - _this28.startBarPointerX, 
                        _this28.moveSldDiff = _this28.moveBarDiff * _this28.scaleRatio, _this28.moveTo = _this28.startBarPosition + _this28.moveSldDiff, 
                        _this28.$sld_wrap.scrollLeft(_this28.moveTo), _this28.check());
                    }), _this28.$doc.on("mouseup.recommend", function() {
                        "sp" !== cmn.p.media && (_this28.$doc.off(".recommend"), _this28.movingFlag = !1, 
                        _this28.$bar_body.removeClass("is-active"));
                    }));
                });
            }
        }, {
            key: "check",
            value: function() {
                this.scrollLeft = this.$sld_wrap.scrollLeft(), this.scrollRatio = this.scrollLeft / this.diff * this.remainRatio, 
                this.$bar_body.css({
                    left: 100 * this.scrollRatio + "%"
                });
            }
        }, {
            key: "heightAdjust",
            value: function() {
                var _this29 = this;
                this.$txt.each(function(i, curH) {
                    curH = $(curH).innerHeight();
                    _this29.maxHeight < curH && (_this29.maxHeight = curH);
                }), this.$txt.css({
                    height: this.maxHeight
                });
            }
        } ]), RecommendScrollSingle;
    }(), RecommendScroll = function() {
        function RecommendScroll(name) {
            var _this30 = this;
            _classCallCheck(this, RecommendScroll), this.name = name, this.option = {}, $(function() {
                $(".recom")[0] && _this30.init();
            }), $(window).on("load", function() {
                _this30.ready && (_this30.resizeW(), _this30.resizeDW());
            });
        }
        return _createClass(RecommendScroll, [ {
            key: "init",
            value: function() {
                var _this31 = this;
                this.ls = [], this.$tgt = $(".recom"), this.$tgt.each(function(i, $this) {
                    $this = $($this);
                    _this31.ls.push(new RecommendScrollSingle($this));
                }), cmn.e.resizeW.push([ this.name, "resizeW" ]), cmn.e.resizeDW.push([ this.name, "resizeDW" ]), 
                this.ready = !0;
            }
        }, {
            key: "resizeW",
            value: function() {
                for (var i = 0, len = this.ls.length; i < len; i++) this.ls[i].setStatus();
            }
        }, {
            key: "resizeDW",
            value: function() {
                for (var i = 0, len = this.ls.length; i < len; i++) this.ls[i].setEvents();
            }
        } ]), RecommendScroll;
    }(), Carousel = function() {
        function Carousel(name) {
            var _this32 = this;
            _classCallCheck(this, Carousel), this.name = name, this.option = {}, $(function() {
                $("[data-carousel]")[0] && _this32.init();
            });
        }
        return _createClass(Carousel, [ {
            key: "init",
            value: function() {
                $("#home")[0] && (this.option.baseDur = 650, this.option.multDur = 50, this.option.interval = 4e3, 
                this.option.auto = !0), $("#product")[0] && (this.option.baseDur = 500, this.option.multDur = 35, 
                this.option.auto = !1), this.anim = !1, this.curId = 0, this.preId = 0, this.cur = 0, 
                this.timer = 0, this.variantList = [], this.$wrp = $("[data-carousel]"), this.$sld = this.$wrp.find("[data-carousel-sld]"), 
                this.$thm = this.$wrp.find("[data-carousel-thm]"), this.$prev = this.$wrp.find("[data-carousel-prev]"), 
                this.$next = this.$wrp.find("[data-carousel-next]"), this.$sldItm = this.$sld.children("li"), 
                this.$sldPar = this.$sld.parent("div"), this.length = this.$sldItm.length, this.$thm[0] && (this.$thmItm = this.$thm.children("li")), 
                1 < this.length ? (this.setParam(), this.clone(), this.checkVariant(!0), this.event()) : this.currentSet(!0), 
                this.finish();
            }
        }, {
            key: "setParam",
            value: function() {
                var _this33 = this;
                this.$sldItm.each(function(i, value) {
                    $(value).addClass("idx-" + i);
                    value = $(value).data("prd-pic");
                    _this33.variantList[i] = value ? value + "" : "";
                });
            }
        }, {
            key: "clone",
            value: function() {
                var $f1 = this.$sldItm.eq(0).clone(), $f2 = this.$sldItm.eq(1).clone(), $l1 = this.$sldItm.eq(this.length - 1).clone(), $l2 = this.$sldItm.eq(this.length - 2).clone();
                this.$sld.prepend($l1).prepend($l2).append($f1).append($f2), this.$sldAll = this.$sld.children("li");
            }
        }, {
            key: "event",
            value: function() {
                var _this34 = this;
                this.$prev[0] && this.$prev.on("click", function() {
                    _this34.anim || _this34.slide(_this34.cur - 1);
                }), this.$next[0] && this.$next.on("click", function() {
                    _this34.anim || _this34.slide(_this34.cur + 1);
                }), this.$thm[0] && this.$thmItm[0] && this.$thmItm.on("click", function(e) {
                    _this34.anim || _this34.slide(_this34.$thmItm.index($(e.currentTarget)));
                }), this.$sldPar.on("touchstart", function(e) {
                    _this34.anim || _this34.flick(e);
                });
            }
        }, {
            key: "checkVariant",
            value: function(init) {
                var idx;
                !cmn.p.variant || -1 === (idx = this.variantList.indexOf(cmn.p.variant)) ? this.slide(this.cur, init) : this.slide(idx, init);
            }
        }, {
            key: "slide",
            value: function(idx, init, distance) {
                var _this35 = this;
                if (idx !== this.cur || distance) {
                    if (init) return this.$sld.css({
                        right: 100 * idx + "%"
                    }), this.cur = idx, void this.currentSet();
                    this.anim = !0, this.timer = 0, this.preId = this.curId++;
                    distance = Math.abs(idx - this.cur);
                    idx < 0 ? this.cur = this.length - 1 : this.length <= idx ? this.cur = 0 : this.cur = idx, 
                    this.currentSet(), this.$sld.stop(!0, !1).animate({
                        right: 100 * idx + "%"
                    }, (this.option.baseDur + distance * this.option.multDur) * ("pc" === cmn.p.media ? 1 : .8), "easeOutCubic", function() {
                        _this35.$sld.css({
                            right: 100 * _this35.cur + "%"
                        }), _this35.anim = !1, _this35.timer = 0;
                    });
                } else init && this.currentSet();
            }
        }, {
            key: "currentSet",
            value: function(single) {
                single ? (this.$sldItm.addClass("is-cur"), this.$thm[0] && this.$thmItm[0] && this.$thmItm.addClass("is-cur")) : (this.$sldAll.removeClass("is-cur"), 
                this.$sld.children(".idx-" + this.cur).addClass("is-cur"), this.$thm[0] && this.$thmItm[0] && (this.$thmItm.removeClass("is-cur"), 
                this.$thmItm.eq(this.cur).addClass("is-cur")));
            }
        }, {
            key: "finish",
            value: function() {
                this.ready = !0, 1 < this.length && (this.$sld.addClass("has-slide"), this.$thm[0] && this.$thm.addClass("is-active"), 
                this.$prev[0] && this.$prev.addClass("is-active"), this.$next[0] && this.$next.addClass("is-active"), 
                this.option.auto && this.auto()), this.$wrp.addClass("is-ready");
            }
        }, {
            key: "auto",
            value: function() {
                var _this36 = this;
                setInterval(function() {
                    _this36.timer++, 10 <= _this36.timer && (_this36.timer = 0, _this36.slide(_this36.cur + 1));
                }, this.option.interval / 10);
            }
        }, {
            key: "flick",
            value: function(pre) {
                var _this37 = this, pos = {}, pre = pre.originalEvent.changedTouches[0], wid = this.$sldPar.width();
                this.timer = 0, pos.preX = pre.pageX, pos.preY = pre.pageY, this.$sldPar.on("touchmove.flick", function(e) {
                    var right = e.originalEvent.changedTouches[0];
                    _this37.timer = 0, pos.curX = right.pageX, pos.curY = right.pageY, pos.diffX = pos.curX - pos.preX, 
                    pos.diffY = pos.curY - pos.preY, Math.abs(pos.diffY) < Math.abs(pos.diffX) ? (right = 100 * _this37.cur - pos.diffX / wid * 100, 
                    _this37.$sld.css({
                        right: right + "%"
                    }), e.preventDefault()) : (_this37.slide(_this37.cur, 0, 1), _this37.$sldPar.off(".flick"));
                }), this.$sldPar.on("touchend.flick", function(e) {
                    pos.diffX > wid / 10 ? _this37.slide(_this37.cur - 1) : pos.diffX < -wid / 10 ? _this37.slide(_this37.cur + 1) : _this37.slide(_this37.cur, 0, 1), 
                    _this37.timer = 0, _this37.$sldPar.off(".flick");
                });
            }
        } ]), Carousel;
    }(), TextareaHeightFix = function() {
        function TextareaHeightFix(name) {
            var _this38 = this;
            _classCallCheck(this, TextareaHeightFix), this.name = name, this.option = {}, $(function() {
                $(".textareaBody")[0] && $(".textareaDummy")[0] && _this38.init();
            });
        }
        return _createClass(TextareaHeightFix, [ {
            key: "init",
            value: function() {
                var _this39 = this;
                this.$body = $(".textareaBody"), this.$dumm = $(".textareaDummy"), this.check(), 
                this.$body.on("change keyup keydown paste cut", function(e) {
                    _this39.check();
                });
            }
        }, {
            key: "check",
            value: function() {
                var value = this.$body.val();
                "" !== value ? this.$dumm.text(value + "\n\n") : this.$dumm.text("");
            }
        } ]), TextareaHeightFix;
    }(), FormCheckSingle = function() {
        function FormCheckSingle($wrap, name) {
            _classCallCheck(this, FormCheckSingle), this.name = name, this.$wrap = $wrap, this.mail_regex = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/, 
            this.tel_regex = /^\+?\d[0-9- ]{3,}\d$/, this.zip_regex = /^\d{3}\-?\d{4}$/, this.init();
        }
        return _createClass(FormCheckSingle, [ {
            key: "init",
            value: function() {
                var _this40 = this;
                this.$tgt = this.$wrap.find("[data-formcheck]"), this.$btn = this.$wrap.find("[data-formbtn]"), 
                this.setFillAll(), this.setBtn(), this.$tgt.on("change keyup paste cut blur", function($this) {
                    $this = $($this.currentTarget), $this.parent("div");
                    _this40.setFill($this), _this40.setNvl($this), _this40.setBtn();
                }), this.$btn.on("mouseenter", function(e) {
                    null != _this40.$btn.attr("disabled") && _this40.setNvlAll();
                }), setTimeout(function() {
                    _this40.setFillAll();
                }, 1e3);
            }
        }, {
            key: "setNvl",
            value: function($this, forceToRemove) {
                var $par = $this.parent("div");
                forceToRemove || this.checkVaridation($this) ? $par.removeClass("is-nvl") : $par.addClass("is-nvl");
            }
        }, {
            key: "setFill",
            value: function($this) {
                $this.val() ? $this.addClass("is-filled") : $this.removeClass("is-filled");
            }
        }, {
            key: "setNvlAll",
            value: function() {
                var _this41 = this;
                this.$tgt.each(function(idx, $this) {
                    $this = $($this);
                    _this41.setNvl($this);
                });
            }
        }, {
            key: "setFillAll",
            value: function() {
                var _this42 = this;
                this.$tgt.each(function(idx, $this) {
                    $this = $($this);
                    _this42.setFill($this);
                });
            }
        }, {
            key: "setToInit",
            value: function() {
                var _this43 = this;
                this.$tgt.each(function(idx, $this) {
                    $this = $($this);
                    _this43.setFill($this), _this43.setNvl($this, !0), _this43.setBtn();
                });
            }
        }, {
            key: "setBtn",
            value: function(init) {
                var _this44 = this, flag = 1;
                this.$tgt.each(function(idx, $this) {
                    $this = $($this);
                    if (!_this44.checkVaridation($this)) return flag = 0, !1;
                }), flag ? this.$btn.removeAttr("disabled") : this.$btn.attr({
                    disabled: "disabled"
                });
            }
        }, {
            key: "checkVaridation",
            value: function(typ) {
                var val = typ.val(), typ = typ.data("formcheck");
                return -1 === typ.indexOf("exist") && !val || !(-1 != typ.indexOf("exist") && !val) && (!(-1 != typ.indexOf("mail") && !this.mail_regex.test(val)) && (!(-1 != typ.indexOf("tele") && !this.tel_regex.test(val)) && !(-1 != typ.indexOf("zip") && !this.zip_regex.test(val))));
            }
        } ]), FormCheckSingle;
    }(), FormCheck = function() {
        function FormCheck(name) {
            var _this45 = this;
            _classCallCheck(this, FormCheck), this.name = name, this.option = {}, $(function() {
                $("[data-formwrap]")[0] && _this45.init();
            });
        }
        return _createClass(FormCheck, [ {
            key: "init",
            value: function() {
                var _this46 = this;
                this.ls = {}, this.$wrap = $("[data-formwrap]"), this.$wrap.each(function(name, $this) {
                    $this = $($this), name = "form" + name;
                    $this.data("formwrap", name), _this46.ls[name] = new FormCheckSingle($this, name);
                });
            }
        } ]), FormCheck;
    }(), EditAddress = function() {
        function EditAddress(name) {
            var _this47 = this;
            _classCallCheck(this, EditAddress), this.name = name, this.option = {
                baseDur: 350,
                divRatio: 8
            }, $(function() {
                $("#addressList")[0] && _this47.init();
            });
        }
        return _createClass(EditAddress, [ {
            key: "init",
            value: function() {
                var _this48 = this;
                this.anim = !1, this.$editBtn = $("[data-addredit]"), this.$cnclBtn = $("[data-addrcancel]"), 
                this.$editBtn.on("click", function(e) {
                    _this48.edit($(e.currentTarget));
                }), this.$cnclBtn.on("click", function(e) {
                    _this48.cancel($(e.currentTarget));
                });
            }
        }, {
            key: "edit",
            value: function($tgt) {
                if (this.anim) return !1;
                $tgt = $tgt.data("addredit"), $tgt = $($tgt);
                if (!$tgt[0]) return !1;
                $tgt.hasClass("is-open") ? this.close($tgt) : this.open($tgt);
            }
        }, {
            key: "cancel",
            value: function($tgt) {
                if (this.anim) return !1;
                $tgt = $tgt.data("addrcancel"), $tgt = $($tgt);
                if (!$tgt[0]) return !1;
                $tgt.hasClass("is-open") && this.close($tgt);
            }
        }, {
            key: "open",
            value: function($tgt) {
                var _this49 = this, hgt = $tgt.children("div").innerHeight();
                this.anim = !0, $tgt.addClass("is-open"), $tgt.animate({
                    height: hgt
                }, this.option.baseDur + hgt / this.option.divRatio, "easeInOutCubic", function() {
                    $tgt.css({
                        height: "auto"
                    }), _this49.anim = !1;
                });
            }
        }, {
            key: "close",
            value: function($tgt) {
                var _this50 = this, hgt = $tgt.children("div").innerHeight();
                this.anim = !0, $tgt.removeClass("is-open"), $tgt.css({
                    height: hgt
                }).animate({
                    height: 0
                }, this.option.baseDur + hgt / this.option.divRatio, "easeInOutCubic", function() {
                    _this50.reset($tgt), _this50.anim = !1;
                });
            }
        }, {
            key: "reset",
            value: function(name) {
                var $data = name.find(".addrData"), $chck = name.find(".addrCheck").find("input");
                $data.each(function(i, $this) {
                    $this = $($this);
                    $this.val($this.data("default"));
                }), $chck.prop("checked", !1);
                name = name.find("[data-formwrap]").data("formwrap");
                cmn.i._FormCheck.ls[name].setToInit();
            }
        } ]), EditAddress;
    }(), DeleteAddress = function() {
        function DeleteAddress(name) {
            var _this51 = this;
            _classCallCheck(this, DeleteAddress), this.name = name, this.option = {}, $(function() {
                $("#addressList")[0] && _this51.init();
            });
        }
        return _createClass(DeleteAddress, [ {
            key: "init",
            value: function() {
                this.$delete = $(".addrDelete"), this.$delete.on("submit", function() {
                    return !!window.confirm("住所を削除してよろしいですか？");
                });
            }
        } ]), DeleteAddress;
    }(), LoginToggle = function() {
        function LoginToggle(name) {
            var _this52 = this;
            _classCallCheck(this, LoginToggle), this.name = name, this.option = {}, $(function() {
                $("#loginForm")[0] && $("#recoverForm")[0] && _this52.init();
            });
        }
        return _createClass(LoginToggle, [ {
            key: "init",
            value: function() {
                var _this53 = this;
                this.$lgi = $("#loginForm"), this.$rcv = $("#recoverForm"), this.$toRcv = $(".toRcvBtn"), 
                this.$toLgi = $(".toLgiBtn"), this.check(), this.$lgi.css({
                    visibility: "visible"
                }), this.$rcv.css({
                    visibility: "visible"
                }), this.$toRcv.on("click", function() {
                    return location.hash = "#recover", _this53.check(), !1;
                }), this.$toLgi.on("click", function() {
                    return location.hash = "", _this53.check(), !1;
                });
            }
        }, {
            key: "check",
            value: function() {
                this.hash = location.hash, "#recover" === this.hash ? (this.$lgi.css({
                    display: "none"
                }), this.$rcv.css({
                    display: "block"
                })) : (this.$rcv.css({
                    display: "none"
                }), this.$lgi.css({
                    display: "block"
                }));
            }
        } ]), LoginToggle;
    }(), SlideToggle = function() {
        function SlideToggle(name) {
            var _this54 = this;
            _classCallCheck(this, SlideToggle), this.name = name, this.option = {
                baseDur: 250,
                baseDiv: 6
            }, $(function() {
                $("[data-slidetoggle]")[0] && _this54.init();
            });
        }
        return _createClass(SlideToggle, [ {
            key: "init",
            value: function() {
                var _this55 = this;
                this.$btn = $("[data-slidetoggle]"), this.$btn.on("click", function(e) {
                    return !_this55.anim && void _this55.toggle($(e.currentTarget));
                });
            }
        }, {
            key: "toggle",
            value: function($this) {
                var _this56 = this, hgt = $this.data("slidetoggle"), $tgt = $(hgt);
                if (!$tgt[0]) return !1;
                this.anim = !0;
                hgt = $tgt.children("div").innerHeight();
                $this.hasClass("is-open") ? ($this.removeClass("is-open"), $tgt.css({
                    height: hgt
                }).animate({
                    height: 0
                }, this.option.baseDur + hgt / this.option.baseDiv, "easeOutCubic", function() {
                    _this56.anim = !1;
                })) : ($this.addClass("is-open"), $tgt.animate({
                    height: hgt
                }, this.option.baseDur + hgt / this.option.baseDiv, "easeOutCubic", function() {
                    $tgt.css({
                        height: "auto"
                    }), _this56.anim = !1;
                }));
            }
        } ]), SlideToggle;
    }(), CategoryScrollSingle = function() {
        function CategoryScrollSingle($wrap) {
            _classCallCheck(this, CategoryScrollSingle), this.$wrap = $wrap, this.option = {}, 
            $($wrap)[0] && this.init();
        }
        return _createClass(CategoryScrollSingle, [ {
            key: "init",
            value: function() {
                var _this57 = this;
                this.$sld_wrap = this.$wrap.find(".cll__ch__fld__in"), this.$sld_body = this.$wrap.find(".cll__ch__fld__ls"), 
                this.$bar_wrap = this.$wrap.find(".cll__ch__bar"), this.$bar_body = this.$wrap.find(".cll__ch__bar__bd"), 
                this.setStatus(!0), this.$sld_wrap.on("scroll.recommend", function() {
                    _this57.check();
                });
            }
        }, {
            key: "setStatus",
            value: function(scrL) {
                if ("pc" !== cmn.p.media) {
                    if (this.wid_sw = this.$sld_wrap.innerWidth(), this.wid_sb = this.$sld_body.innerWidth(), 
                    this.wid_bw = this.$bar_wrap.innerWidth(), this.diff = this.wid_sb - this.wid_sw, 
                    this.diff <= 0) return this.$sld_wrap.removeClass("has-bar"), void this.$bar_wrap.removeClass("is-shown");
                    scrL && (this.$cur = this.$sld_body.find("li.is-cur"), !this.$cur[0] || 50 < (scrL = this.$cur.position().left - 10) && this.$sld_wrap.scrollLeft(scrL)), 
                    this.sliderRatio = this.wid_sw / this.wid_sb, this.remainRatio = 1 - this.sliderRatio, 
                    this.scrollLeft = this.$sld_wrap.scrollLeft(), this.scrollRatio = this.scrollLeft / this.diff * this.remainRatio, 
                    this.$bar_body.css({
                        width: 100 * this.sliderRatio + "%",
                        left: 100 * this.scrollRatio + "%"
                    }), this.$sld_wrap.addClass("has-bar"), this.$bar_wrap.addClass("is-shown");
                }
            }
        }, {
            key: "check",
            value: function() {
                this.scrollLeft = this.$sld_wrap.scrollLeft(), this.scrollRatio = this.scrollLeft / this.diff * this.remainRatio, 
                this.$bar_body.css({
                    left: 100 * this.scrollRatio + "%"
                });
            }
        } ]), CategoryScrollSingle;
    }(), CategoryScroll = function() {
        function CategoryScroll(name) {
            var _this58 = this;
            _classCallCheck(this, CategoryScroll), this.name = name, this.option = {}, $(function() {
                $(".cll__ch")[0] && _this58.init();
            }), $(window).on("load", function() {
                _this58.ready && _this58.update();
            });
        }
        return _createClass(CategoryScroll, [ {
            key: "init",
            value: function() {
                var _this59 = this;
                this.ls = [], this.$tgt = $(".cll__ch"), this.$tgt.each(function(i, $this) {
                    $this = $($this);
                    _this59.ls.push(new CategoryScrollSingle($this));
                }), cmn.e.resizeW.push([ this.name, "update" ]), this.ready = !0;
            }
        }, {
            key: "update",
            value: function() {
                if ("pc" !== cmn.p.media) for (var i = 0, len = this.ls.length; i < len; i++) this.ls[i].setStatus();
            }
        } ]), CategoryScroll;
    }();
    new function _init() {
        var u, c;
        _classCallCheck(this, _init), u = navigator.userAgent.toLowerCase(), c = /ipad/.test(u) || /android/.test(u) && !/mobile/.test(u) ? "width=1440" : "width=device-width, initial-scale=1", 
        c = /Mac OS/.test(navigator.userAgent) && void 0 !== document.ontouchstart && !/iphone/.test(u) ? "width=1440" : c, 
        document.getElementById("viewport").setAttribute("content", c), $.extend($.easing, {
            easeInQuad: function(x, t, b, c, d) {
                return c * (t /= d) * t + b;
            },
            easeOutQuad: function(x, t, b, c, d) {
                return -c * (t /= d) * (t - 2) + b;
            },
            easeInOutQuad: function(x, t, b, c, d) {
                return (t /= d / 2) < 1 ? c / 2 * t * t + b : -c / 2 * (--t * (t - 2) - 1) + b;
            },
            easeInCubic: function(x, t, b, c, d) {
                return c * (t /= d) * t * t + b;
            },
            easeOutCubic: function(x, t, b, c, d) {
                return c * ((t = t / d - 1) * t * t + 1) + b;
            },
            easeInOutCubic: function(x, t, b, c, d) {
                return (t /= d / 2) < 1 ? c / 2 * t * t * t + b : c / 2 * ((t -= 2) * t * t + 2) + b;
            },
            easeInQuart: function(x, t, b, c, d) {
                return c * (t /= d) * t * t * t + b;
            },
            easeOutQuart: function(x, t, b, c, d) {
                return -c * ((t = t / d - 1) * t * t * t - 1) + b;
            },
            easeInOutQuart: function(x, t, b, c, d) {
                return (t /= d / 2) < 1 ? c / 2 * t * t * t * t + b : -c / 2 * ((t -= 2) * t * t * t - 2) + b;
            },
            easeInQuint: function(x, t, b, c, d) {
                return c * (t /= d) * t * t * t * t + b;
            },
            easeOutQuint: function(x, t, b, c, d) {
                return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
            },
            easeInOutQuint: function(x, t, b, c, d) {
                return (t /= d / 2) < 1 ? c / 2 * t * t * t * t * t + b : c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
            },
            easeInSine: function(x, t, b, c, d) {
                return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
            },
            easeOutSine: function(x, t, b, c, d) {
                return c * Math.sin(t / d * (Math.PI / 2)) + b;
            },
            easeInOutSine: function(x, t, b, c, d) {
                return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
            },
            easeInExpo: function(x, t, b, c, d) {
                return 0 == t ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
            },
            easeOutExpo: function(x, t, b, c, d) {
                return t == d ? b + c : c * (1 - Math.pow(2, -10 * t / d)) + b;
            },
            easeInOutExpo: function(x, t, b, c, d) {
                return 0 == t ? b : t == d ? b + c : (t /= d / 2) < 1 ? c / 2 * Math.pow(2, 10 * (t - 1)) + b : c / 2 * (2 - Math.pow(2, -10 * --t)) + b;
            },
            easeInCirc: function(x, t, b, c, d) {
                return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
            },
            easeOutCirc: function(x, t, b, c, d) {
                return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
            },
            easeInOutCirc: function(x, t, b, c, d) {
                return (t /= d / 2) < 1 ? -c / 2 * (Math.sqrt(1 - t * t) - 1) + b : c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
            }
        }), cmn.e = {
            scroll: [],
            scrollY: [],
            scrollX: [],
            scrollF: [],
            scrollD: [],
            resize: [],
            resizeW: [],
            resizeH: [],
            resizeD: [],
            resizeDW: [],
            resizeDH: [],
            toPc: [],
            toSp: []
        }, cmn.p = {
            media: "",
            docH: 0,
            winW: 0,
            winH: 0,
            scrT: 0,
            scrL: 0,
            ns: !1
        }, cmn.g = new _cmnEvt(), cmn.m = new _cmnMth(), cmn.i = {
            _AnchorLink: new AnchorLink("_AnchorLink"),
            _HeaderCategory: new HeaderCategory("_HeaderCategory"),
            _HeaderCustomer: new HeaderCustomer("_HeaderCustomer"),
            _HeaderSpbtn: new HeaderSpbtn("_HeaderSpbtn"),
            _FixedElemAdjust: new FixedElemAdjust("_FixedElemAdjust"),
            _SortChanger: new SortChanger("_SortChanger"),
            _ProductVariant: new ProductVariant("_ProductVariant"),
            _ProductFollow: new ProductFollow("_ProductFollow"),
            _NumberChange: new NumberChange("_NumberChange"),
            _RecommendScroll: new RecommendScroll("_RecommendScroll"),
            _Carousel: new Carousel("_Carousel"),
            _TextareaHeightFix: new TextareaHeightFix("_TextareaHeightFix"),
            _FormCheck: new FormCheck("_FormCheck"),
            _EditAddress: new EditAddress("_EditAddress"),
            _DeleteAddress: new DeleteAddress("_DeleteAddress"),
            _LoginToggle: new LoginToggle("_LoginToggle"),
            _SlideToggle: new SlideToggle("_SlideToggle"),
            _CategoryScroll: new CategoryScroll("_CategoryScroll")
        };
    }();
} ]);



/***ヘッダーinfo ***/
$(function(){
  $(window).scroll(function () {
     if ($(this).scrollTop() < 50) {
       pTop = "ON";
     } else {
       pTop = "OFF";
     }
  });
});



/***メルマガポップアップ ***/
$(function(){
  $('.btn_p_newsletter').click(function () {
    $('.pop_area_ml').fadeIn().css('display','flex');
  });
  
  $('.ml_pop_close').click(function () {
    $('.pop_area_ml').fadeOut();
  });
  
  $('form#newsletter_pop').submit(function() { 
    $('.pop_area_ml').fadeOut();
  }); 
});



var curURL = document.URL;
if(curURL.match(/collections/)){   //URLにinformationがある時に
  if(curURL.match(/\?/)){//URLにパラメーターが既についているか判断する。
  }else{
    location.href = curURL + "?display=grid"
  }
}